import type { TrackingAdapter } from '../core';

export const createYfxTrackingAdapter = (): TrackingAdapter => {
  return {
    name: 'yfx',
    init: () => {},
    track: (eventName, data) => {
      if (!window._yfx_trackdata) return;
      window._yfx_trackdata = window._yfx_trackdata || [];
      window._yfx_trackdata.push(['event', 'buried', eventName, data]);
    },
    login: (userId, username) => {
      if (!window._yfx_trackdata) return;
      // 页面打开触发-一般用于打开新页面采集数据
      window._yfx_trackdata = window._yfx_trackdata || [];
      const user_arr = { userid: userId, username };
      window._yfx_trackdata.push(['userset', user_arr]);
      if (!window._dgt) return;
      window._dgt = window._dgt || [];
      window._dgt.push(['track_userid', userId]);
      window._dgt.push(['trackAttr', ['username'], [username]]);
    },
  };
};
